<template>
    <div class="mainWrap">

        <div id="logins" style="position: relative;">
            <FormLogin @login="onLogin" @forgotPassword="onForgot" :backgroundImage="imageLogin" :logoImage="pathLogo"
                titleText="" :show-back-button="false" :show-register-button="false" />

            <!-- Spinner assoluto sopra il form -->
            <div class="spinner-overlay" v-if="showSpinner">
                <rise-loader :size="'20px'" :color="'#1ab14e'" />
            </div>


        </div>

        <div class="contpopupotplogin" style="display:none">

            <template>
                <modal name="popupOtpLogin" :clickToClose="false" :width="262" :height="221">


                    <v-row>

                        <v-col cols="12" md="12"
                            style="margin-top:10px!important;font-weight:bold;font-size:12px;text-align: center;">

                            {{ titoloPopupOtp }}

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <v-text-field type="text" v-model="valueOtpLogin" label="" id="fldValueOtpLoginEmt"
                                onkeydown="if (!/^[0-9]$/.test(event.key) && event.key !== 'Backspace') event.preventDefault();">
                            </v-text-field>

                        </v-col>

                    </v-row>

                    <v-row v-if="showResend">

                        <v-col cols="12" md="12" style="display: flex;
            justify-content: center;
            padding-top: 0px!important;
            margin-top: 0px!important;
            font-size:12px">

                            <div style="font-weight: bold;
            cursor: pointer;" class="clReinviaOtp">Reinvia</div>

                        </v-col>

                    </v-row>


                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-otp-login" contain src="@/assets/btn_cancel3_hdtool.png"
                                    max-width="30" max-height="30" style="cursor:pointer;color:black;margin-right:10px"
                                    transition="scale-transition" title="Annulla" @click="btnCancelOtpLogin" />

                                <v-img alt="" class="btn-confirm-otp-login" contain
                                    src="@/assets/btn_confirm3_hdtool.png" max-width="30" max-height="30"
                                    style="cursor:pointer" transition="scale-transition" title="Conferma"
                                    @click="btnConfirmOtpLogin" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>

        <div class="contpopupqrgoogle" style="display:none">

            <template>
                <modal name="popupQRGoogle" :clickToClose="false" :width="344" :height="329">


                    <v-row>

                        <v-col cols="12" md="12"
                            style="margin-top:10px!important;font-weight:bold;font-size:12px;text-align: center;">

                            Scansiona con Google Authenticator il QR Code

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12" style="display: flex;justify-content: center;">

                            <canvas ref="qrcode"></canvas>

                        </v-col>

                    </v-row>


                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-qrcode-google" contain
                                    src="@/assets/btn_cancel3_hdtool.png" max-width="30" max-height="30"
                                    style="cursor:pointer;color:black;margin-right:10px" transition="scale-transition"
                                    title="Annulla" @click="btnCancelQRCodeGoogle" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <div class="contpopupotpgoogle" style="display:none">

            <template>
                <modal name="popupOtpGoogle" :clickToClose="false" :width="337" :height="317">

                    <v-row style="margin-bottom: 0px!important;padding-bottom: 0px!important;">

                        <v-col cols="12" md="12"
                            style="margin-top:10px!important;font-weight:bold;font-size:12px;text-align: center;display:flex;justify-content: center;margin-bottom: 0px!important;padding-bottom: 0px!important;">

                            <img class="logo" src="@/assets/logo_auth.png" style="max-width: 40px" />


                        </v-col>

                    </v-row>


                    <v-row style="margin-top: 0px!important;padding-top: 0px!important">

                        <v-col cols="12" md="12"
                            style="margin-top:10px!important;font-weight:bold;font-size:12px;text-align: center;display:flex;justify-content: center;">

                            <div style="width: 310px;">
                                Apri l'APP Authenticator del tuo smartphone e genera il codice OTP.
                                Dura 30 secondi, attendi una nuova generazione prima di inserirlo

                            </div>

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <v-text-field type="text" v-model="valueOtpLogin" label="" id="fldValueOtpLoginEmt"
                                onkeydown="if (!/^[0-9]$/.test(event.key) && event.key !== 'Backspace') event.preventDefault();">
                            </v-text-field>

                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-cancel-otp-google" contain
                                    src="@/assets/btn_cancel3_hdtool.png" max-width="30" max-height="30"
                                    style="cursor:pointer;color:black;margin-right:10px" transition="scale-transition"
                                    title="Annulla" @click="btnCancelOtpGoogle" />

                                <v-img alt="" class="btn-confirm-otp-google" contain
                                    src="@/assets/btn_confirm3_hdtool.png" max-width="30" max-height="30"
                                    style="cursor:pointer" transition="scale-transition" title="Conferma"
                                    @click="btnConfirmOtpGoogle" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


    </div>
</template>

<script>
import FormLogin from "@/components/FormLogin.vue";
import $ from 'jquery';
import RiseLoader from "vue-spinner/src/RiseLoader.vue";
import router from ".././router";

import logo from '@/assets/loginstart/img/hdtoollogo2.png'


import QRCode from 'qrcode';



export default {
    components:
    {
        FormLogin, RiseLoader

    },

    mounted: function () {



        this.pathLogo = logo;


        document.title = "hdtool";


        this.imageLogin = this.getUrlImageButton("public/_lib/img/image-hdtool.png");



    },

    data() {
        return {


            pathLogo: "",
            showSpinner: false,
            showResend: true,
            valueOtpLogin: "",
            mailUser: "",
            valueUserName: "",
            imageLogin: "",

            titoloPopupOtp: "",

        };
    },


    methods: {

        getUrlDomainHdtool: function (nome_metodo) {

            let result = "";

            if ($(location).attr('hostname') == "localhost") {
                result = $(location).attr('protocol') + "//emtool.local/";
            }

            if ($(location).attr('hostname') != "localhost") {

                result = "https://companysupport.eu/";

            }

            return result + "public/api/hdtool/" + nome_metodo;

        },

        getEnableConf: function (v_codice) {

            var result = 0;

            var v_product_permissions = window.$cookies.get("product_permissions");

            var elements = v_product_permissions.split("|");

            for (var x = 0; x <= elements.length - 1; x++) {

                if (elements[x] == v_codice) {

                    result = 1;

                }


            }


            return result;

        },


        getUrlDomainSimple2: function (nome_metodo) {

            let result = "";

            if ($(location).attr('hostname') == "localhost") {
                result = $(location).attr('protocol') + "//emtool.local/";
            }

            if ($(location).attr('hostname') != "localhost") {

                result = "https://app.emtool.eu/";

            }

            return result + "" + nome_metodo;

        },

        redirecta: function (v_page) {


            var settSmartbook = JSON.parse(window.$cookies.get("settHdToolLogin"));
            console.log("settSmartbook", settSmartbook[0]);
            var settings = settSmartbook[0];

            if (settings != null) {


                var backgroundImage = settings.backgroundImage;

                var txt_image = this.getUrlDomainSimple("public/documents/hdtool/assets/" + backgroundImage);


                var rule = ` .bkc_over_image {background-image :url(` + txt_image + `)!important}`;


                $('#addedCSS').text(rule);


            }

            setTimeout(() => {
                router.push({
                    path: v_page
                });
            }, 300);

        },

        loginAction3: async function () {

            var that = this;

            that.showSpinner = true;

            const url2 = this.getUrlDomain("verifyTwoFactorAuth");

            let formData6 = new FormData();
            formData6.append("username", btoa(that.valueUserName));
            formData6.append("val_code", that.valueOtpLogin);

            await this.axios
                .post(url2, formData6, {
                    "content-type": "application/json"
                })
                .then((result6) => {

                    that.showSpinner = false;

                    console.log("RESULT6: ", result6);

                    if (result6.data.Result == "OK") {

                        that.$modal.hide('popupOtpGoogle');


                        that.loginAction2(that.valueUserName);

                    }
                    else {

                        that.valueOtpLogin = "";

                        that.$swal({
                            icon: "error",
                            text: result6.data.ErrDetails,
                            showConfirmButton: false,
                            timer: 3000
                        });

                        setTimeout(() => {

                            $("#fldValueOtpLoginEmt").focus();

                        }, 300);


                    }



                });

        },

        btnConfirmOtpGoogle: async function () {

            if (this.valueOtpLogin != "") {

                this.loginAction3();


            }
            else {


                $("#fldValueOtpLoginEmt").focus();

                this.$swal({
                    icon: "error",
                    text: "Specificare un  valore del codice",
                    showConfirmButton: false,
                    timer: 2000
                });

            }

        },

        btnCancelOtpGoogle: function () {

            this.$modal.hide('popupOtpGoogle');


        },

        btnCancelQRCodeGoogle: function () {

            this.$modal.hide('popupQRGoogle');


            setTimeout(() => {


                $(".contpopupotpgoogle").show();

                this.$modal.show('popupOtpGoogle');

                setTimeout(() => {

                    $("#fldValueOtpLoginEmt").focus();

                }, 300);


            }, 200);


        },

        getUrlDomainApi: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = location.protocol + "//emtool.local/";
            }

            if (location.hostname != "localhost") {

                result = "https://companysupport.eu/";

            }

            return result + "api/" + nome_metodo;

        },


        loginAction2: async function (v_username) {

            const url2 = this.getUrlDomainApi("pswUserIsChanged");

            let formData2 = new FormData();
            formData2.append("username", v_username);
            formData2.append("spec_psw", window.spec_psw);

            await this.axios
                .post(url2, formData2, {
                    "content-type": "application/json"
                })
                .then((result2) => {

                    this.showSpinner = false;

                    console.log("RESULT2: ", result2);

                    setTimeout(() => {

                        window.$cookies.set("is_pwd_changed_once", result2.data.IsChanged, "9y");

                    }, 1);

                    if (result2.data.IsChanged == 0) {


                        setTimeout(() => {
                            router.push({
                                path: "/changepasswordinitial"
                            });

                        }, 300);




                    }

                    if (result2.data.IsChanged == 1) {

                        setTimeout(() => {


                            var uname = v_username;
                            const args = [uname, true, ['bar', 5], {
                                foo: 'baz'
                            }];
                            try {
                                console.log("entering user");
                                window.flutter_inappwebview.callHandler('setLoggedUser', ...args);

                            } catch (error) {
                                // alert(error);
                            }

                            this.$root.$children[0].curDipTop = window.namesurname;

                            //update menu after login
                            this.$root.$children[0].changeMenu();
                            //Load companies array
                            this.$root.$children[0].syncMonth();
                            this.$root.$children[0].syncGroups();

                            this.$root.$children[0].refreshMenu();

                            this.$root.$children[0].registerLogin();


                            setTimeout(() => {
                                router.push({
                                    path: "/dash"
                                });

                            }, 300);












                        }, 1);


                    }



                });

        },

        getUrlDomain: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = location.protocol + "//emtool.local/";
            }

            if (location.hostname != "localhost") {

                result = "https://companysupport.eu/";

            }

            return result + nome_metodo;

        },

        getUrlDomainSimple: function (nome_metodo) {

            let result = "";

            if ($(location).attr('hostname') == "localhost") {
                result = $(location).attr('protocol') + "//emtool.local/";
            }

            if ($(location).attr('hostname') != "localhost") {

                result = $(location).attr('protocol') + "//" + $(location).attr('hostname') + "/";

            }

            return result + "" + nome_metodo;

        },

        getUrlImageButton: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = location.protocol + "//emtool.local/";
            }

            if (location.hostname != "localhost") {

                result = $(location).attr('protocol') + "//" + $(location).attr('hostname') + "/";

            }

            return result + nome_metodo;

        },


        btnCancelOtpLogin: function () {

            this.$modal.hide('popupOtpLogin');


        },

        btnConfirmOtpLogin: function () {


            if (this.valueOtpLogin != "") {

                console.log("OTP INP: ", this.valueOtpLogin);
                console.log("ENC OTP INP: ", btoa(this.valueOtpLogin));

                if (window.myVal == btoa(this.valueOtpLogin)) {

                    this.$modal.hide('popupOtpLogin');


                    this.loginAction2(this.valueUserName);


                }
                else {


                    this.$swal({
                        icon: "error",
                        text: "Valore OTP non corretto",
                        showConfirmButton: false,
                        timer: 2000
                    });

                    setTimeout(() => {

                        this.valueOtpLogin = "";
                        $("#fldValueOtpLoginEmt").focus();

                    }, 2500);


                }



            }
            else {


                $("#fldValueOtpLoginEmt").focus();

                this.$swal({
                    icon: "error",
                    text: "Specificare un  valore dell'OTP",
                    showConfirmButton: false,
                    timer: 2000
                });

            }



        },



        getUrlLoginApiGo: function () {

            let result = "";

            if (location.hostname == "localhost") {
                result = "http://localhost:4020/checkLogin";
            }

            if (location.hostname != "localhost") {

                result = "https://filestransfer.it:4020/checkLogin";

            }

            return result;

        },


        loginAction: async function (v_username, v_password) {

            var pointerVue = this;


            this.showSpinner = true;

            const url = this.getUrlLoginApiGo();

            this.success = false;
            this.error = null;

            let formData = new FormData();
            formData.append("user", v_username);
            formData.append("password", v_password);
            formData.append("productid", "hdtool");


            var login = v_username;
            console.log(login);

            try {
                await this.axios
                    .post(url, formData, {
                        "content-type": "application/json"
                    })
                    .then(async (result) => {
                        var respo = result.data;
                        this.success = true;
                        console.log("RESPO: ", respo);
                        console.log("LOGIN: ", login);

                        window.v_respo = respo;

                        if (respo.Result == "OK") {

                            if (respo.product_enable == 1) { // prodotto abilitato

                                setTimeout(() => {

                                    window.namesurname = respo.namesurname;
                                    window.typeLogin = respo.typeLogin;
                                    window.mobile = respo.mobile;
                                    window.prefix_mobile = respo.prefix_mobile;
                                    window.namesurname = respo.namesurname;
                                    window.a = respo.a;
                                    window.b = respo.b;
                                    window.token = respo.token;

                                    window.$cookies.set("a", respo.a, "9y");
                                    window.$cookies.set("b", respo.b, "9y");
                                    window.$cookies.set("token", respo.token, "9y");
                                    window.$cookies.set("system", respo.system, "9y");
                                    window.$cookies.set("token_system", respo.token_system, "9y");
                                    window.$cookies.set("username", respo.username, "9y");
                                    window.$cookies.set("user_id", respo.user_id, "9y");
                                    window.$cookies.set("namesurname", respo.namesurname, "9y");
                                    window.$cookies.set("is_ebadge", respo.is_ebadge, "9y");
                                    window.$cookies.set("is_cust_supp", respo.isCustOrSupplier.length, "9y");
                                    window.$cookies.set("is_agila", respo.is_agila, "9y");
                                    window.$cookies.set("models", respo.models, "9y");
                                    window.$cookies.set("product_permissions", respo.product_permissions, "9y");
                                    window.$cookies.set("settHdToolLogin", JSON.stringify(respo.settProduct), "9y");

                                    window.$cookies.set("readOnlyHdTool", respo.readOnlyHdTool, "9y");
                                    window.$cookies.set("filterHdToolTicketByOwner", respo.filterHdToolTicketByOwner, "9y");

                                }, 1);


                                try { // verifico se è la prima volta che accede gli chiedo cambio pwd


                                    if (respo.typeLogin == "OTP") {

                                        this.showSpinner = true;

                                        const url2 = this.getUrlDomain("generateOtpAndSendMail");

                                        let formData2 = new FormData();
                                        formData2.append("username", btoa(this.valueUserName));
                                        formData2.append("name_product", "emt");
                                        formData2.append("tipo_op", "login");
                                        formData2.append("v_id", 0);

                                        await this.axios
                                            .post(url2, formData2, {
                                                "content-type": "application/json"
                                            })
                                            .then((result2) => {

                                                this.showSpinner = false;

                                                console.log("RESULT2: ", result2);

                                                window.myVal = result2.data.Result;


                                                setTimeout(() => {

                                                    this.showResend = true;

                                                    this.valueOtpLogin = "";

                                                    this.titoloPopupOtp = "Codice OTP inviatoLe via mail";

                                                    $(".contpopupotplogin").show();

                                                    this.$modal.show('popupOtpLogin');

                                                    setTimeout(() => {

                                                        $("#fldValueOtpLoginEmt").focus();

                                                    }, 300);


                                                }, 200);

                                            });

                                    }




                                    if (respo.typeLogin == "SMS") {

                                        this.showSpinner = true;

                                        const url2 = this.getUrlDomain("generateOtpAndSendSMS");

                                        let formData3 = new FormData();
                                        formData3.append("username", btoa(this.input.username));
                                        formData3.append("name_product", "emt");
                                        formData3.append("mobile", respo.mobile);
                                        formData3.append("prefix_mobile", respo.prefix_mobile);

                                        await this.axios
                                            .post(url2, formData3, {
                                                "content-type": "application/json"
                                            })
                                            .then((result3) => {

                                                this.showSpinner = false;

                                                console.log("RESULT2: ", result3);


                                                if (result3.data.Result == "OK") {



                                                    window.myVal = result3.data.ValReturn;


                                                    setTimeout(() => {

                                                        this.showResend = true;

                                                        this.valueOtpLogin = "";

                                                        this.titoloPopupOtp = "Codice OTP inviatoLe via SMS";


                                                        $(".contpopupotplogin").show();

                                                        this.$modal.show('popupOtpLogin');

                                                        setTimeout(() => {

                                                            $("#fldValueOtpLoginEmt").focus();

                                                        }, 300);


                                                    }, 200);


                                                }
                                                else {

                                                    this.$swal({
                                                        icon: "error",
                                                        text: result3.data.ErrDetails,
                                                        showConfirmButton: false,
                                                        timer: 3000
                                                    });

                                                }







                                            });

                                    }



                                    if (respo.typeLogin == "Authenticator") {

                                        this.showSpinner = true;

                                        const url2 = this.getUrlDomain("enableTwoFactorAuth");

                                        let formData4 = new FormData();
                                        formData4.append("username", btoa(this.input.username));

                                        await this.axios
                                            .post(url2, formData4, {
                                                "content-type": "application/json"
                                            })
                                            .then((result4) => {

                                                this.showSpinner = false;

                                                console.log("RESULT2: ", result4);


                                                if (result4.data.Result == "OK") {

                                                    if (result4.data.view_qrcode == 1) {

                                                        setTimeout(() => {


                                                            $(".contpopupqrgoogle").show();

                                                            this.$modal.show('popupQRGoogle');

                                                            setTimeout(() => {

                                                                QRCode.toCanvas(this.$refs.qrcode, result4.data.qrCodeUrl, function (error) {
                                                                    if (error) console.error(error);
                                                                });

                                                            }, 300);


                                                        }, 200);

                                                    }



                                                    if (result4.data.view_qrcode == 0) {

                                                        setTimeout(() => {


                                                            $(".contpopupotpgoogle").show();

                                                            this.$modal.show('popupOtpGoogle');

                                                            this.valueOtpLogin = "";

                                                            setTimeout(() => {

                                                                $("#fldValueOtpLoginEmt").focus();

                                                            }, 300);


                                                        }, 200);

                                                    }




                                                }
                                                else {

                                                    this.$swal({
                                                        icon: "error",
                                                        text: result4.data.ErrDetails,
                                                        showConfirmButton: false,
                                                        timer: 3000
                                                    });

                                                }







                                            });

                                    }





                                    if (respo.typeLogin == "SMS_ERR_TEL_NUMBER") {

                                        this.showSpinner = false;

                                        this.$swal({
                                            icon: "error",
                                            text: "Numero di Telefono non impostato correttamente, chiedere all'amministratore",
                                            showConfirmButton: false,
                                            timer: 4000
                                        });


                                    }




                                    if (respo.typeLogin == "") {

                                        setTimeout(() => {

                                            window.$cookies.set("is_pwd_changed_once", respo.IsChanged, "9y");

                                        }, 1);

                                        if (respo.IsChanged == 0) { // password da cambiare

                                            setTimeout(() => {
                                                router.push({
                                                    path: "/changepasswordinitial"
                                                });

                                            }, 300);

                                        }

                                        if (respo.IsChanged == 1) { // password valida

                                            setTimeout(() => {


                                                var goHome = 0;
                                                var isSU = 0;
                                                if ((respo.a == "Y") || (respo.a == "S")) {
                                                    isSU = 1;
                                                }
                                                if (isSU == 0) {
                                                    var enableTicket = this.getEnableConf("ticket_hdtool");
                                                    if (enableTicket == 0) {
                                                        goHome = 1;
                                                    }
                                                }


                                                var uname = v_username;
                                                const args = [uname, true, ['bar', 5], {
                                                    foo: 'baz'
                                                }];
                                                try {
                                                    console.log("entering user");
                                                    window.flutter_inappwebview.callHandler('setLoggedUser', ...args);

                                                } catch (error) {
                                                    // alert(error);
                                                }

                                                this.$root.$children[0].curDipTop = respo.namesurname;

                                                this.$root.$children[0].refreshMenu();

                                                //update menu after login
                                                this.$root.$children[0].changeMenu();
                                                //Load companies array
                                                // this.$root.$children[0].syncMonth();
                                                // this.$root.$children[0].syncGroups();


                                                this.$root.$children[0].registerLogin();



                                                if (goHome == 0) {

                                                    // load generic info
                                                    $.ajax({
                                                        type: "POST",
                                                        url: pointerVue.getUrlDomainHdtool("getSettings") + '?v_user=' + respo.token,
                                                        success: function (resultData) {

                                                            console.log("GET SETTINGS: ", JSON.stringify(resultData));


                                                            localStorage.setItem('info_global', JSON.stringify(resultData));

                                                            console.log("RESULT_DATA", JSON.stringify(resultData));




                                                            pointerVue.redirecta("/initTicketTree");


                                                        }
                                                    });



                                                }
                                                else {

                                                    // load generic info
                                                    $.ajax({
                                                        type: "POST",
                                                        url: pointerVue.getUrlDomainHdtool("getSettings") + '?v_user=' + respo.token,
                                                        success: function (resultData) {

                                                            console.log("GET SETTINGS: ", JSON.stringify(resultData));


                                                            localStorage.setItem('info_global', JSON.stringify(resultData));

                                                            console.log("RESULT_DATA", JSON.stringify(resultData));


                                                            pointerVue.redirecta("/dash");



                                                        }
                                                    });


                                                }




                                            }, 1);



                                        }



                                    }





                                }
                                catch (err2) {
                                    this.success = false;
                                    console.log(err2.message);
                                    this.$swal({
                                        icon: "error",
                                        text: "Errore durante verifica password"
                                    });

                                    this.showSpinner = false;
                                }


                            }
                            else {

                                this.$swal({
                                    icon: "error",
                                    text: "Prodotto non abilitato",
                                    showConfirmButton: false,
                                    timer: 3000
                                });

                                this.showSpinner = false;


                            }

                        }
                        else {

                            this.success = false;
                            this.$swal({
                                icon: "error",
                                text: respo.ErrDetails,
                                confirmButtonText: "<img title='Conferma' style='width:30px' src='https://old.emtool.eu/public/_lib/img/btn_confirm3_hdtool.png' />",
                                cancelButtonText: "<img title='Annulla' style='width:30px' src='https://old.emtool.eu/public/_lib/img/btn_cancel3_hdtool.png' />",
                                showCancelButton: false,
                                customClass: {
                                    cancelButton: 'order-1',
                                    confirmButton: 'order-2',
                                }
                            });

                            this.showSpinner = false;




                        }














                    });
            } catch (err) {
                this.success = false;
                console.log(err.message);
                this.$swal({
                    icon: "error",
                    text: "Credenziali sbagliate",
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://old.emtool.eu/public/_lib/img/btn_confirm3_invoiceweb.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://old.emtool.eu/public/_lib/img/btn_cancel3_invoiceweb.png' />",
                });

                this.showSpinner = false;
            }
        },

        getCookie() {
            this.$cookies.set("cookie-consent-performance", "yes");
        },

        onLogin(credentials) {
            console.log("LOGIN:", credentials);
            // chiamata API...

            console.log("USERNAME:", credentials.username);
            console.log("PASSWORD:", credentials.password);

            this.getCookie();

            this.valueUserName = credentials.username;

            this.loginAction(credentials.username, credentials.password);

        },

        onForgot(username) {
            console.log("FORGOT PASSWORD:", username);
            // apre modal, manda email, ecc...
            this.recover();
        },

        getUrlDomainGo: function (nome_metodo) {

            let result = "";

            if (location.hostname == "localhost") {
                result = "http://localhost:4007/";
            }

            if (location.hostname != "localhost") {

                result = "https://jobmule.eu:4007/";

            }

            return result + nome_metodo;

        },

        recover: function () {
            // this.showSpinner = true;



            var spinner = $("#bspinner");
            var loginButton = $("#login-button");

            var API_URL = this.getUrlDomain("resetPwdEmtApp");

            var that = this;

            this.$swal
                .fire({
                    title: "Password recovery",
                    html: "Type your username",
                    /*  icon: "warning", */
                    showCancelButton: true,
                    confirmButtonText: "<img title='Conferma' style='width:30px' src='https://old.emtool.eu/public/_lib/img/btn_confirm3_hdtool.png' />",
                    cancelButtonText: "<img title='Annulla' style='width:30px' src='https://old.emtool.eu/public/_lib/img/btn_cancel3_hdtool.png' />",
                    customClass: {
                        cancelButton: 'order-1',
                        confirmButton: 'order-2',
                    },

                    input: "text",

                    inputAttributes: {
                        autocapitalize: "off",
                    },

                    preConfirm: (username) => {
                        // console.log(username);

                        // show spinner && disable button
                        spinner.removeClass("vhidden");
                        that.showSpinner = true;

                        loginButton.prop("disabled", true);

                        var body = {
                            user: username,
                            method: "SEND_OLD_PASSWORD",
                            site_domain: "https://app.emtool.eu/",
                            product: 'Emt'
                        };

                        console.log(body);
                        // call the service
                        $.ajax({
                            type: "POST",
                            url: API_URL,
                            data: body,
                            success: function (resultData) {

                                console.log("RESULTDATA: ", resultData);

                                // hide spinner && enable button
                                spinner.addClass("vhidden");
                                that.showSpinner = false;

                                loginButton.prop("disabled", false);

                                if (resultData.Result == "OK") {
                                    var message;

                                    message = "Check your email";

                                    //open ok modal


                                    that.$swal.fire({
                                        icon: "success",
                                        title: message,
                                        showConfirmButton: false,
                                        timer: 2000
                                    });
                                } else {
                                    var errorMessage;

                                    switch (resultData.Result) {
                                        case "USER_NOT_FOUND":
                                            errorMessage = "Utente non trovato";
                                            break;
                                        default:
                                            errorMessage = "Utente non trovato";
                                    }

                                    that.$swal.fire({
                                        title: "Errore",
                                        text: errorMessage,
                                        icon: "error",
                                        showConfirmButton: false,
                                        timer: 2000
                                    });

                                    that.showSpinner = false;
                                }



                            },
                            error: function () {
                                // hide spinner && enable login button
                                spinner.addClass("vhidden");
                                loginButton.prop("disabled", false);
                                that.showSpinner = false;
                                //  errorHandler(event);
                            },
                        });
                    },

                });


            setTimeout(() => {


                $(".swal2-input").val(that.input.username);


            }, 500);





        },
    }
};
</script>

<style>
#logins {
    position: relative;
}

/* Posizione assoluta per lo spinner subito sotto il contenuto del form */
.spinner-overlay {
    position: absolute;
    top: 693px;
    /* regolare in base al contenuto del form */
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
}

.clBtnBack {
    width: 40px;
    margin-top: 45px;
    cursor: pointer;
}

html,
body {
    height: auto;
    /* lascia crescere il contenuto */
    margin: 0;
    padding: 0;
    overflow-y: auto;
    /* scroll verticale automatico se il contenuto eccede la viewport */
    -webkit-overflow-scrolling: touch;
    /* scroll fluido su iOS */
}

.mainWrap {
    min-height: 100%;
    /* permette al contenuto di crescere con la pagina */
    overflow-y: auto;
    /* scroll verticale automatico se necessario */
}
</style>